import PropTypes from 'prop-types';
/* eslint class-methods-use-this: 0 */
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import BigModal from 'web-react-ui/src/BigModal/BigModal';
import Menu from 'web-react-ui/src/components/collections/Menu';
import CancelButton from 'web-react-ui/src/components/elements/CancelButton';
import View from 'web-react-ui/src/components/layout/View';
import LocaleSelector from 'web-react-ui/src/reactFinalForm/fields/localizableField/LocaleSelector';
import LocalizableSimpleForm from 'web-react-ui/src/reactFinalForm/fields/localizableField/LocalizableSimpleForm';
import FormSubmit from 'web-react-ui/src/reactFinalForm/FormSubmit';
import { atLeastOneCompleteLocalization } from 'web-react-ui/src/reactFinalForm/validators';

import propertyModule from '../../modules/property';
import client from '../../services/client';
import ConnectedTranslationWrapper from '../i18n/ConnectedTranslationWrapper';
import { findScorePreset } from './defaultCollectionScores';
import EditCollectionForm from './EditCollectionForm';

const Buttons = ({ onCancel }) => (
  <Menu secondary>
    <Menu.Item fitted>
      <CancelButton onClick={onCancel} />
    </Menu.Item>
    <Menu.Menu position='right'>
      <Menu.Item fitted>
        <FormSubmit label='Save' ignoreValidity />
      </Menu.Item>
    </Menu.Menu>
  </Menu>
);

Buttons.propTypes = {
  onCancel: PropTypes.func
};

class Presenter extends Component {
  static propTypes = {
    property: PropTypes.object,
    collectionId: PropTypes.string,
    dispatch: PropTypes.func
  };

  state = {};

  fetchCollection() {
    const { property, collectionId } = this.props;
    return client.properties.for(property.id).collections.edit(collectionId)
      .then(collectionEdit => this.setState({ collectionEdit }));
  }

  handleCancel() {
    const { collectionId, property } = this.props;
    this.setState({ redirectTo: `/${property.id}/collections/${collectionId}` });
  }

  handleSubmit(fields) {
    const { property } = this.props;
    const { collectionEdit } = this.state;

    this.setState({ isSaving: true, error: null });
    return collectionEdit.update(fields)
      .then((collectionUpdate) => {
        const collectionId = collectionUpdate.instances.collection.id;
        this.setState({ redirectTo: `/${property.id}/collections/${collectionId}` });
        this.setState({ isSaving: false });
      })
      .catch((error) => {
        this.setState({ isSaving: false });
        return Promise.reject(error);
      });
  }

  componentDidMount() {
    this.fetchCollection();
  }

  render() {
    const { property } = this.props;
    const { collectionEdit, isSaving, redirectTo } = this.state;
    if (redirectTo) return <Redirect to={redirectTo} />;

    const initialValues = collectionEdit && collectionEdit.getFields();
    if (initialValues) initialValues.collectionScores = findScorePreset(initialValues.collection.scores);

    return (
      <BigModal open={true}>
        <ConnectedTranslationWrapper>
          <LocalizableSimpleForm
            onSubmit={this.handleSubmit.bind(this)}
            initialValues={initialValues}
            loading={!collectionEdit || isSaving}
            validateLocale={atLeastOneCompleteLocalization([
              'collection.nameLocalized', 'collection.shortNameLocalized'
            ])}
          >
            <BigModal.Contents>
              <BigModal.Header className='p1'>
                <Buttons onCancel={this.handleCancel.bind(this)} />
              </BigModal.Header>
              <BigModal.Body>
                <View>
                  <View.Section>
                    <div className='flex'>
                      <h1>Edit Collection</h1>
                      <LocaleSelector className='mla' />
                    </div>
                    <EditCollectionForm propertyId={property.id} />
                  </View.Section>
                  <div className='p1'>
                    <Buttons onCancel={this.handleCancel.bind(this)} />
                  </div>
                </View>
              </BigModal.Body>
            </BigModal.Contents>
          </LocalizableSimpleForm>
        </ConnectedTranslationWrapper>
      </BigModal>
    );
  }
}

const mapState = state => ({
  property: propertyModule.selectors.property.getData(state)
});

export { Presenter };
export default connect(mapState)(Presenter);
